import { ValueRules as ValueRules_2_0_0, AtachmentRules as AtachmentRules_2_0_0, OptionValueRules as OptionValueRules_2_0_0 } from './QuestionnaireRecipes_2_0_0.js';
import { QuestionnaireRules as QuestionnaireRules_2_1_0 } from './QuestionnaireRecipes_2_1_0.js';
import { cloneRule, overwriteRule, removeRule } from '../RecipeUtils.js';
export const AtachmentRules = cloneRule(AtachmentRules_2_0_0);
removeRule(AtachmentRules, 'contentType');
AtachmentRules.push({
    itemprop: 'contentType',
    itemtype: { type: 'string' },
    optional: true
});
export const ValueRules = cloneRule(ValueRules_2_0_0);
removeRule(ValueRules, 'valueAttachment');
ValueRules.push({
    itemprop: 'valueAttachment',
    itemtype: { type: 'object', rules: AtachmentRules },
    optional: true
});
/**
 * The rules to build a questionnaire based on FHIR
 */
export const QuestionnaireRules = cloneRule(QuestionnaireRules_2_1_0);
overwriteRule(QuestionnaireRules, 'item', {
    itemprop: 'item',
    inheritFrom: 'Questionnaire_2_1_1.item',
    optional: true
});
overwriteRule(QuestionnaireRules, 'item', {
    itemprop: 'initial',
    itemtype: {
        type: 'bag',
        item: {
            type: 'object',
            rules: ValueRules
        }
    },
    optional: true
});
/**
 * Recipe for questionnaires based upon FHIR standard.
 *
 * @type {{name: string; rule: RecipeRule[]; $type$: string}}
 */
export const QuestionnaireRecipe = {
    $type$: 'Recipe',
    name: 'Questionnaire_2_1_1',
    rule: QuestionnaireRules
};
const QuestionnaireRecipes = [QuestionnaireRecipe];
export default QuestionnaireRecipes;
//# sourceMappingURL=QuestionnaireRecipes_2_1_1.js.map